import script from "./DateCustomFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DateCustomFilter.vue?vue&type=script&setup=true&lang=js"

import "./DateCustomFilter.vue?vue&type=style&index=0&id=9863fac6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9863fac6"]])

export default __exports__